export enum vaidationType {
  numberOnly,
  emailOnly,
  arabicOnly,
  englishOnly,
  arabicAndEnglish,
  numberwithstarOnly
}
